export default __webpack_public_path__ + "static/media/one.b1f0775b.jpeg";